import React from 'react';
import './Radio.scss';

export interface RadioProps {
    label?: string;
    id?: string;
    name?: string;
    checked?: boolean;
    disabled?: boolean;
    required?: boolean;
    className?: string;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    value?: string | number;
    ariaLabel?: string;
    ariaLabelledBy?: string;
}

const Radio: React.FC<RadioProps> = (props) => {
    return (
        <label className={'radioBtn ' + props.className} htmlFor={props.id}>
            <span className="container">
                {props.label}
                <input
                    type="radio"
                    id={props.id}
                    name={props.name}
                    value={props.value}
                    onChange={props.onChange}
                    checked={props.checked}
                    disabled={props.disabled}
                    required={props.required || undefined}
                    aria-required={props.required ? true : undefined}
                    aria-label={props.ariaLabelledBy ? undefined : (!props.label ? props.ariaLabel : undefined)}
                    aria-labelledby={props.ariaLabelledBy}
                />
                <span className="checkmark" aria-hidden="true"></span>
            </span>
        </label>
    );
};

export default Radio;
